import { UserTabOption } from "../Util";

export const CurrentUserTabOption = [
    ...UserTabOption,
    {
        label: "Users",
    }
];
